import styled, { css } from "styled-components"

const StyledSwatchSquare = styled.div`
  width: 25px;
  height: 25px;
  overflow: hidden;
  margin-right: 5px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  &:hover {
    cursor: pointer;
  }

  ${(p) =>
    p.isActive
      ? css`
          border: 2px solid #c30004;
          padding: 1px;
        `
      : null}
`

export default StyledSwatchSquare
